<template>
  <div class="md:relative lg:relative md:pb-0 lg:pb-0" id="joinvolunteer">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto mob-hidden"
    />
    <div class="absolute bg-design4 md:block lg:block hidden">
      <img
        src="../../../assets/images/bg-des/bgd4.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design5 md:block lg:block hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>

    <div class="lg:flex md:flex w-full items-center">
      <div class="lg:w-1/2 md:w-1/2 w-full h-full flex items-center">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Partnerwithus%20-%20Volunteer.jpg"
          alt=""
          class="m-auto custborderradius banner-short-w500 alignimg-aboutus md:block lg:block"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:pl-20 md:pl-10">
        <div class="">
          <p class="title-semibold fsize36-24px">
            We are a Volunteer-powered organisation
          </p>
          <p class="joinus-subtitle md:pt-10 lg:pt-10 pt-4 fsize24-14px">
            Help us drive our purpose to create an ecosystem of well-being for
            caregivers and care-receivers. We will find a suitable role that
            fits your expertise.
            <br />
            All age groups are welcome!
          </p>
          <div class="md:pt-10 lg:pt-10 pt-6">
            <base-button
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 font-semibold border-2 fsize18px"
              @click="handleRoute('request-form', 'work-at-cgs-as-volunteer')"
            >
              <!-- <a
                target="_blank"
                class="hover:text-white"
                href="https://forms.office.com/r/vctepmjfcA"
                > -->
              Volunteer
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
